export default __webpack_public_path__ + "static/media/276.b9fefdf6.png";